import { render } from "./B2bRouterView.vue?vue&type=template&id=8fc347e6&lang=pug"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__